/// \file equipmentModelsRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const EquipmentModelsList = lazy(() => import('../views/equipment-models/list/view'));

async function equipmentModelsDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/equipment-models/list/loader')).default;
  return actualLoader(args);
}

export async function equipmentModelsAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/equipment-models/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="OemEquipmentModels"
    handle={{
      text: 'OEM Equipment Models'
    }}
    >
    <Route
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <EquipmentModelsList />
        </Suspense>
      }
      loader={equipmentModelsDataLoader}
      action={equipmentModelsAction}
    />
  </Route>
);

export default routes;